
export default {
  path: '/credit_transfer_payment_runs',
  name: 'credit_transfer_payment_runs',
  component: () => import('../components/credittransferpaymentrun/Layout'),
  redirect: { name: 'CreditTransferPaymentRunList' },
  children: [
    {
      name: 'CreditTransferPaymentRunList',
      path: '',
      component: () => import('../views/credittransferpaymentrun/List')
    },
    {
      name: 'CreditTransferPaymentRunCreate',
      path: 'new',
      component: () => import('../views/credittransferpaymentrun/Create')
    },
    {
      name: 'CreditTransferPaymentRunUpdate',
      path: ':id/edit',
      component: () => import('../views/credittransferpaymentrun/Update')
    },
    {
      name: 'CreditTransferPaymentRunShow',
      path: ':id',
      component: () => import('../views/credittransferpaymentrun/Show')
    }
  ]
};
